import {
  React,
  useEffect,
  useState,
  Dashboard,
  UploadOutlined,
  DownloadOutlined,
  message,
  axios,
  swal,
  exportFromJSON,
  Papa,
  TinCountTable,
  Button,
} from "./import";
import { DatePicker } from "antd";
import moment from "moment";
import { api } from "../../../config";
import ReactLoading from "react-loading";

const { RangePicker } = DatePicker;

function TinUpload() {
  // States
  const [csvFile, setCSVFile] = useState(null);
  const [error, setError] = useState("");
  const [defaultDate, setDefaultDate] = useState([]);
  const [load, setLoad] = useState(false);

  //disable date logic -{Lovejot- 23-08-2022}

  const disabledDate = (current) => {
    // 90 DAYS GAP AND DISABLE TOMORROW
    return (
      // current.isBefore(moment().subtract(90, "day")) ||
      // current > moment().endOf("day")
      current && current > moment().endOf("day")
    );
  };

  //DATE FILTER
  const handleDate = (value, dateString) => {
    console.log("date is ", value, dateString);
    if (value === null) {
      setDefaultDate([
        moment(new Date()).format("YYYY-MM-DD"),
        moment(new Date()).format("YYYY-MM-DD"),
      ]);
    } else {
      setDefaultDate(dateString);
    }
  };

  const popup = (e) => {
    if (e === "noFile") {
      message.warn("Please Select a file", 5);
    }
  };

  let data = [
    {
      tinNo: 3232,
      tinType: "Voice"
    },
    {
      tinNo: 323342,
      tinType: "Written"
    },
  ];
  const exportType = "csv";

  const handleClickSample = () => {
    exportFromJSON({ data, exportType });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    console.log("file casetype", file)
    setCSVFile(file);
    Papa.parse(file, {
      header: true,
      complete: (results) => {
        const headers = results.meta.fields;
        const isValid = headers.length === 2 && headers.includes("tinNo") && headers.includes("tinType");
        if (isValid) {
          console.log("Headers are valid!", file);
          setError("");
          setCSVFile(file);
        } else {
          message.warn("Headers are Not valid!");
          setError("Headers are Not valid!");
        }
      },
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (csvFile) {
      if (error) {
        message.warn("Headers are Not valid!");
      } else {
        setLoad(true);
        var data = new FormData();
        data.append("", csvFile);

        var config = {
          method: "post",
          maxBodyLength: Infinity,
          url: `manageTin/uploadBulkTin/${localStorage.getItem("user.id")}`,
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user.token")}`,
          },
          data: data,
        };

        axios(config)
          .then(function (response) {
            console.log(JSON.stringify(response.data));
            swal({
              title: `${response.data.NewRecords}/${response.data.TotalCount} New Records Inserted`,
              text: `${response.data.AlreaydExist} Already registered`,
              icon: "success",
              dangerMode: true,
            }).then((willDelete) => {
              if (willDelete) {
                const downloadUrl = `${api}/${response.data.DownloadFileUrl}`;
                const link = document.createElement("a");
                link.href = downloadUrl;
                link.download = "file.csv";
                link.click();
                setTimeout(() => {
                  window.location.reload();
                }, 1000);
              }
            });
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(() => {
            // setTimeout(()=>{
            //   window.location.reload()
            // },2000)
            setLoad(false);
          });
      }
    } else {
      popup("noFile");
    }
  };

  function formatDate(d) {
    let date = new Date(d);
    var dd = date.getDate();
    var mm = date.getMonth() + 1;
    var yyyy = date.getFullYear();
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var seconds = date.getSeconds();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    return (d =
      dd + "/" + mm + "/" + yyyy + " " + hours + ":" + minutes + ":" + seconds);
  }
  const downloadCsv = () => {
    setLoad(true);
    axios
      .get(
        `manageTin/DownloadTinReports/All?StartDate=${
          defaultDate[0]
            ? defaultDate[0]
            : moment(new Date()).format("YYYY-MM-DD")
        }&EndDate=${
          defaultDate[1]
            ? defaultDate[1]
            : moment(new Date()).format("YYYY-MM-DD")
        }`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user.token")}`,
          },
        }
      )
      .then((res) => {
        const datas = res?.data?.tinList?.map(
          ({ assignUserId, candidateId, uploadUserId, ...rest }) => ({
            assignUserId: assignUserId?._id || "",
            assignUserName: assignUserId?.name || "",
            assignUserEmail: assignUserId?.email || "",
            candidateId: candidateId?._id || "",
            candidateName: candidateId?.name || "",
            uploadUserId: uploadUserId._id,
            uploadUserName: uploadUserId.name,
            uploadUserEmail: uploadUserId.email,
            uploadUserRole: uploadUserId.role,
            ...rest,
          })
        );

        const tinFormat = datas.map((ele) => {
          return {
            name: ele?.uploadUserName,
            role: ele?.uploadUserRole,
            email: ele?.uploadUserEmail,
            tin: ele?.tinNo,
            tinType: ele?.tinType,
            tinStatus: ele?.tinStatus ? "Active" : "inActive",
            createdAt: ele?.createdAt ? formatDate(ele?.createdAt) : "",
            updatedAt: ele?.updatedAt ? formatDate(ele?.updatedAt) : "",
          };
        });
        let fileName = `TIN_UPLOAD_REPORT_${moment(new Date()).format(
          "DD-MM-YYYY_HH:mm"
        )}`;
        let data = tinFormat;
        exportFromJSON({ data, fileName, exportType });
      })
      .finally((res) => {
        setLoad(false);
      });
  };

  return (
    <Dashboard title="Tin Upload">
      {load && (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      )}
      <div className="row bg-white cursor-pointer p-3 border mb-2 d-flex align-items-center ">
        <div className="col-md-6">
          <div className="row">
            {/* <div className="col-md-4">
              <select className="form-control" value={"tin filter"}>
                <option value="">Select Tin Type</option>
              </select>
            </div> */}
            <div className="col-md-4">
              <label htmlFor="csv-file">Choose a CSV file :</label>
              <input
                type="file"
                id="csv-file"
                accept=".csv"
                onChange={handleFileChange}
              />
            </div>
            <div className="col-md-8 d-flex align-items-center mb-1">
              <button
                className="btn btn-primary ml-2 mr-2 mt-1"
                onClick={handleSubmit}
              >
                <i class="fa fa-upload" aria-hidden="true"></i>
              </button>
              <button
                className="btn btn-primary mt-1"
                onClick={handleClickSample}
              >
                <i class="fa fa-download mr-2" aria-hidden="true"></i>
                Download Sample
              </button>
            </div>
          </div>
        </div>
        <div className="col-md-6 d-flex justify-content-end">
          <RangePicker
            format="YYYY-MM-DD"
            defaultValue={[moment(), moment()]}
            onChange={handleDate}
            // onOk={onOk}
            disabledDate={disabledDate}
            placeholder={[
              moment(new Date()).format("YYYY-MM-DD"),
              moment(new Date()).format("YYYY-MM-DD"),
            ]}
            className="mr-2"
          />
          <button className="btn btn-primary" onClick={downloadCsv}>
            <i class="fa fa-download" aria-hidden="true"></i>
          </button>
        </div>
      </div>
      <TinCountTable />
    </Dashboard>
  );
}

export default TinUpload;
